/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeAccessLog { 
    id?: string;
    documentId: string;
    versionId?: string;
    userId?: number;
    /**
     * view | download | unlock_success | unlock_failed | denied | code_change | relation_add | relation_remove
     */
    action: string;
    /**
     * IP de origen. Completa solo con el permiso ViewClientIp; si no, recortada (189.203.x.x)
     */
    ipAddress?: string;
    userAgent?: string;
    createdOn?: string;
    createdBy?: number;
}

